export default __webpack_public_path__ + "static/media/confirmImg.d6d647f2.png";